import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, 0)',
    barImage: 'assets/side.jpg',
    drawer: null,
    valorEnviado: true,
    valorLog: false,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_VALOR (state, payload) {
      state.valorEnviado = payload
    },
    SET_LOG (state, payload) {
      state.valorLog = payload
    },
  },
  actions: {

  },
})
